import React from 'react';

const NAV_ITEMS = [
  { id: 'chat', icon: '💬', label: 'Conversas' },
  { id: 'blast', icon: '🚀', label: 'Disparador' },
  { id: 'contacts', icon: '👥', label: 'Contatos' },
  { id: 'agents', icon: '🤖', label: 'Agentes' },
  { id: 'settings', icon: '⚙️', label: 'Config' },
];

export default function Sidebar({ active, onChange, unreadCount, company, onSwitchWorkspace }) {
  const s = {
    sidebar: {
      width: 56,
      background: '#18181b',
      borderRight: '1px solid #27272a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '10px 0',
      gap: 2,
    },
    // Company dot at top — click to switch workspace
    workspaceBtn: {
      width: 34,
      height: 34,
      borderRadius: 9,
      background: company ? company.color + '22' : '#27272a',
      border: `1.5px solid ${company ? company.color + '66' : '#3f3f46'}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      marginBottom: 10,
      fontSize: 13,
      fontWeight: 700,
      color: company?.color || '#71717a',
      transition: 'all 0.15s',
      flexShrink: 0,
    },
    btn: (isActive) => ({
      width: 40,
      height: 40,
      borderRadius: 10,
      border: 'none',
      background: isActive ? 'rgba(99,102,241,0.2)' : 'transparent',
      color: isActive ? '#818cf8' : '#71717a',
      fontSize: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      position: 'relative',
      transition: 'all 0.15s',
    }),
    badge: {
      position: 'absolute',
      top: 6, right: 6,
      width: 8, height: 8,
      background: '#ef4444',
      borderRadius: '50%',
      border: '1.5px solid #18181b',
    },
    spacer: { flex: 1 },
    switchBtn: {
      width: 34,
      height: 34,
      borderRadius: 9,
      border: '1px solid #3f3f46',
      background: 'transparent',
      color: '#52525b',
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      marginTop: 8,
      transition: 'all 0.15s',
    },
  };

  const getInitial = (name) => name ? name[0].toUpperCase() : 'Z';

  return (
    <nav style={s.sidebar}>
      {/* Workspace indicator */}
      <div
        style={s.workspaceBtn}
        onClick={onSwitchWorkspace}
        title={`${company?.name || 'Workspace'} — Trocar empresa`}
      >
        {getInitial(company?.name)}
      </div>

      {NAV_ITEMS.map(item => (
        <button
          key={item.id}
          style={s.btn(active === item.id)}
          onClick={() => onChange(item.id)}
          title={item.label}
        >
          <span>{item.icon}</span>
          {item.id === 'chat' && unreadCount > 0 && <span style={s.badge} />}
        </button>
      ))}

      <div style={s.spacer} />

      {/* Switch workspace */}
      <button
        style={s.switchBtn}
        onClick={onSwitchWorkspace}
        title="Trocar empresa"
        onMouseEnter={e => { e.currentTarget.style.color = '#e4e4e7'; e.currentTarget.style.borderColor = '#6366f1'; }}
        onMouseLeave={e => { e.currentTarget.style.color = '#52525b'; e.currentTarget.style.borderColor = '#3f3f46'; }}
      >
        ⇄
      </button>
    </nav>
  );
}
